export default __webpack_public_path__ + "static/media/ian-vertical-mobile.5fb6c01c.png";